"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.11
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyI9TrainingStatusToJSON = exports.MyI9TrainingStatusFromJSONTyped = exports.MyI9TrainingStatusFromJSON = exports.MyI9TrainingStatus = void 0;
/**
 * The user\'s myI9 training completion status
 * @export
 * @enum {string}
 */
var MyI9TrainingStatus;
(function (MyI9TrainingStatus) {
    MyI9TrainingStatus["NOTCOMPLETE"] = "NOT_COMPLETE";
    MyI9TrainingStatus["COMPLETE"] = "COMPLETE";
    MyI9TrainingStatus["OVERRIDDEN"] = "OVERRIDDEN";
})(MyI9TrainingStatus = exports.MyI9TrainingStatus || (exports.MyI9TrainingStatus = {}));
function MyI9TrainingStatusFromJSON(json) {
    return MyI9TrainingStatusFromJSONTyped(json, false);
}
exports.MyI9TrainingStatusFromJSON = MyI9TrainingStatusFromJSON;
function MyI9TrainingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MyI9TrainingStatusFromJSONTyped = MyI9TrainingStatusFromJSONTyped;
function MyI9TrainingStatusToJSON(value) {
    return value;
}
exports.MyI9TrainingStatusToJSON = MyI9TrainingStatusToJSON;
